export class DBColumn {
  public constructor() {
    this.ColumnName = "";
    this.DisplayText = "";
    this.DBTable = "";
    this.RowPointer = "";
    this.DefaultUOM = "";
  }

  public ColumnName: string;
  public DisplayText: string;
  public DBTable: string;
  public RowPointer: string;
  public DefaultUOM: string;

}
